import { calculateExcelColumnWidths, createExcelSheetData, downloadExcelFile } from '../../shared/excelExport.ts'

export const normalizeDataForExcel = <T extends Record<string, unknown>>(data: T[]): Record<string, unknown>[] => {
  // Process data to ensure it's flat and readable
  return data.map((row) => {
    const newRow: Record<string, unknown> = {}
    Object.keys(row).forEach((key) => {
      const value = row[key]
      if (value instanceof Date) {
        newRow[key] = value.toLocaleDateString()
      } else if (typeof value === 'object' && value !== null) {
        newRow[key] = JSON.stringify(value)
      } else {
        newRow[key] = value
      }
    })
    return newRow
  })
}

export const exportToExcel = async <T extends Record<string, unknown>>(data: T[], fileName: string) => {
  const processedData = normalizeDataForExcel(data)
  const keys = processedData.length > 0 ? Object.keys(processedData[0]) : []
  const columnWidths = calculateExcelColumnWidths(keys, processedData)
  const sheetData = createExcelSheetData(keys, processedData)

  await downloadExcelFile(sheetData, columnWidths, `${fileName || 'export'}`)
}
